/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import {
  DetectionClass_Enum,
  detectionClass_EnumFromJSON,
  detectionClass_EnumToJSON,
} from "../../../../gen/detection/detection_class";
import { AimMode_Enum, aimMode_EnumFromJSON, aimMode_EnumToJSON } from "../../../../gen/semantic_aim/aim_mode";

export const protobufPackage = "skills";

export interface ToggleSemanticAimActionArgs {
  toggleOn: boolean;
  aimMode: AimMode_Enum;
  detectionClass: DetectionClass_Enum;
  numberFramesToAggregate: number;
}

export interface ToggleSemanticAimResultData {
}

export interface ToggleSemanticAimActionStateData {
}

function createBaseToggleSemanticAimActionArgs(): ToggleSemanticAimActionArgs {
  return { toggleOn: false, aimMode: 0, detectionClass: 0, numberFramesToAggregate: 0 };
}

export const ToggleSemanticAimActionArgs = {
  encode(message: ToggleSemanticAimActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.toggleOn === true) {
      writer.uint32(8).bool(message.toggleOn);
    }
    if (message.aimMode !== 0) {
      writer.uint32(16).int32(message.aimMode);
    }
    if (message.detectionClass !== 0) {
      writer.uint32(24).int32(message.detectionClass);
    }
    if (message.numberFramesToAggregate !== 0) {
      writer.uint32(32).int64(message.numberFramesToAggregate);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ToggleSemanticAimActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseToggleSemanticAimActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.toggleOn = reader.bool();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.aimMode = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.detectionClass = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.numberFramesToAggregate = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ToggleSemanticAimActionArgs {
    return {
      toggleOn: isSet(object.toggleOn) ? globalThis.Boolean(object.toggleOn) : false,
      aimMode: isSet(object.aimMode) ? aimMode_EnumFromJSON(object.aimMode) : 0,
      detectionClass: isSet(object.detectionClass) ? detectionClass_EnumFromJSON(object.detectionClass) : 0,
      numberFramesToAggregate: isSet(object.numberFramesToAggregate)
        ? globalThis.Number(object.numberFramesToAggregate)
        : 0,
    };
  },

  toJSON(message: ToggleSemanticAimActionArgs): unknown {
    const obj: any = {};
    if (message.toggleOn === true) {
      obj.toggleOn = message.toggleOn;
    }
    if (message.aimMode !== 0) {
      obj.aimMode = aimMode_EnumToJSON(message.aimMode);
    }
    if (message.detectionClass !== 0) {
      obj.detectionClass = detectionClass_EnumToJSON(message.detectionClass);
    }
    if (message.numberFramesToAggregate !== 0) {
      obj.numberFramesToAggregate = Math.round(message.numberFramesToAggregate);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ToggleSemanticAimActionArgs>, I>>(base?: I): ToggleSemanticAimActionArgs {
    return ToggleSemanticAimActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ToggleSemanticAimActionArgs>, I>>(object: I): ToggleSemanticAimActionArgs {
    const message = createBaseToggleSemanticAimActionArgs();
    message.toggleOn = object.toggleOn ?? false;
    message.aimMode = object.aimMode ?? 0;
    message.detectionClass = object.detectionClass ?? 0;
    message.numberFramesToAggregate = object.numberFramesToAggregate ?? 0;
    return message;
  },
};

function createBaseToggleSemanticAimResultData(): ToggleSemanticAimResultData {
  return {};
}

export const ToggleSemanticAimResultData = {
  encode(_: ToggleSemanticAimResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ToggleSemanticAimResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseToggleSemanticAimResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ToggleSemanticAimResultData {
    return {};
  },

  toJSON(_: ToggleSemanticAimResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ToggleSemanticAimResultData>, I>>(base?: I): ToggleSemanticAimResultData {
    return ToggleSemanticAimResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ToggleSemanticAimResultData>, I>>(_: I): ToggleSemanticAimResultData {
    const message = createBaseToggleSemanticAimResultData();
    return message;
  },
};

function createBaseToggleSemanticAimActionStateData(): ToggleSemanticAimActionStateData {
  return {};
}

export const ToggleSemanticAimActionStateData = {
  encode(_: ToggleSemanticAimActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ToggleSemanticAimActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseToggleSemanticAimActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ToggleSemanticAimActionStateData {
    return {};
  },

  toJSON(_: ToggleSemanticAimActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ToggleSemanticAimActionStateData>, I>>(
    base?: I,
  ): ToggleSemanticAimActionStateData {
    return ToggleSemanticAimActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ToggleSemanticAimActionStateData>, I>>(
    _: I,
  ): ToggleSemanticAimActionStateData {
    const message = createBaseToggleSemanticAimActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
